export default __webpack_public_path__ + "static/media/cholet14.c0e95abc.jpg";